import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { CommentModel } from '@/features/crm/types';

async function getComments(id: number): Promise<CommentModel[]> {
  const api = await getApi();
  const { data } = await api.get(`/crm/cartoes/${id}/comentarios/`, {});
  return data;
}

type QueryFnType = typeof getComments;

function useListComments(id: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-comments', id],
    queryFn: () => getComments(id),
    enabled: !!id,
  });
}

export { getComments, useListComments };
